<template>
  <div class="m_cost_detail">
    <header-back
      :title="title+name"
      @back="toBack"
    />
    <cube-scroll
      ref="scroll"
      :data="costDetailList"
    >
      <div
        ref="dScroll"
        class="scroll"
      >
        <template v-if="costDetailList.length > 0">
          <cube-form
            v-for="dItem in costDetailList"
            :key="dItem.id"
            class="maintain_form"
          >
            <cube-form-group>
              <template v-for="item in costDetailColumns">
                <cube-form-item
                  v-if="item.dataIndex !== 'operate'"
                  :key="item.dataIndex"
                  class="maintain_form_item"
                >
                  <h3
                    class="form_props"
                    v-text="item.title"
                  />
                  <div class="form_content">
                    <span
                      v-if="!isUnit(item.dataIndex)"
                      class="form_item_members"
                      v-text="dItem[item.dataIndex]"
                    />
                    <span v-else>{{ dItem[item.dataIndex] }}{{ $t('message["1526"]') }}</span>
                  </div>
                </cube-form-item>
              </template>
            </cube-form-group>
            <cube-form-group>
              <cube-button
                type="submit"
                class="send_submit_btn"
                @click="sendMaintain(dItem)"
              >
                {{ $t('message["274"]') }}
              </cube-button>
            </cube-form-group>
          </cube-form>
        </template>
        <template v-if="showAdd">
          <cube-form
            class="maintain_form"
            :model="detailSnapForm"
          >
            <cube-form-group>
              <template v-for="item in costDetailColumns">
                <cube-form-item
                  v-if="item.dataIndex !== 'operate'"
                  :key="item.dataIndex"
                  class="maintain_form_item"
                >
                  <h3
                    class="form_props"
                    v-text="item.title"
                  />
                  <div
                    class="form_content"
                    @click="selectContent(item)"
                  >
                    <span
                      v-if="isSelect(item.dataIndex) || item.dataIndex === 'inquirynum'"
                      v-text="detailSnapForm[item.dataIndex]"
                    />
                    <span v-if="isUnit(item.dataIndex)">{{ detailSnapForm[item.dataIndex] }}{{ $t('message["1526"]') }}</span>
                    <cube-input
                      v-if="!isReadonly(item.dataIndex)"
                      v-model.number="detailSnapForm[item.dataIndex]"
                      :name="item.dataIndex"
                      type="number"
                      :clearable="{visible: true, blurHidden: false}"
                      :placeholder="enterPlaceholder"
                      @focus="getFieldName"
                      @input="getFieldValue"
                    />
                    <i
                      v-if="isSelect(item.dataIndex)"
                      class="cubeic-arrow"
                    />
                  </div>
                </cube-form-item>
              </template>
            </cube-form-group>
            <cube-form-group>
              <cost-foot-btn
                :ok-text="saveTxt"
                :isback="false"
                :disabled="isSaveDisabled"
                @cacel="cancelSave"
                @ok="saveCostRecode"
              />
            </cube-form-group>
          </cube-form>
        </template>
      </div>
      <div style="height: 195px" />
    </cube-scroll>
    <div class="bottom_add_btn">
      <cube-button
        v-show="costDetailList.length > 0"
        class="send_submit_btn add_btn"
        @click="addCost"
      >
        {{ $t('message["1346"]') }}
      </cube-button>
    </div>
    <!-- 维护内容popup -->
    <Members
      :visible.sync="showSelect"
      :source-datas="sourceData"
      :default-value="[]"
      @change="getSelectContent"
    />
    <!-- 范围选择popup -->
    <Members
      :visible.sync="showRange"
      :source-datas="sourceData"
      :default-value="[]"
      is-first-last
      @change="getSelectContent"
    />
  </div>
</template>

<script>
import CostFootBtn from './components/CostFooter'
import Members from '@/components/mobile/Members'
import headerBack from '@/components/mobile/HeaderBack'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getFixed } from './common'

// 单个表单最大高度
const MAX_CARD_HEIGHT = 484
export default {
  components: { headerBack, CostFootBtn, Members },
  data () {
    return {
      currentField: '',
      showAdd: true,
      to: {},
      from: {},
      options: {
        click: false
      },
      showRange: false,
      showSelect: false,
      sourceData: [],
      selectKey: '',
      // 防止多次点击提交多次数据
      isSaveDisabled: false
    }
  },
  computed: {
    ...mapState('costMaintain/costDetail', [
      'loadingContent',
      'costDetailColumns',
      'detailSnapForm',
      'sendDetailFormData',
      'inqueeryNum',
      'costDetail',
      'costDetailTitle',
      'scrollEnd',
      'costContentData',
      'fromDataLists'
    ]),
    ...mapState(['baseinfo']),
    period () {
      const { period } = this.$route.query
      return period
    },
    title () {
      const { key } = this.$route.query
      return key
    },
    name () {
      return this.costDetailTitle
    },
    costDetailList () {
      return this.costDetail.map(item => {
        item.maintainContent = item.memberStr.join(' / ')
        item.maintainFrom = item.fromStr.join(' / ')
        return item
      })
    },
    saveTxt () {
      return this.$t('message["21"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  watch: {
    costDetail (newVal) {
      const { name } = this.from
      if (['CostMaintain', 'CostSelectMain'].includes(name) || Object.is(name, null)) {
        this.showAdd = newVal.length === 0
      }
    },
    baseinfo (newVal) {
      document.title = this.$t('message["105"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.initFormData()
  },
  async mounted () {
    await this.fetchMaintainTeam()
    await this.fetchGetMessageSource()
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      vm.to = to
      vm.from = from
      vm.clearSendDetailFormData()
      await vm.fetchGetCostDetail({ period: vm.period })
    })
  },
  beforeRouteLeave (to, from, next) {
    const { name } = to
    if (name === 'CostMaintain') {
      // 清楚选中的内容和范围
      this.initDetailSnapForm()
    }
    next()
  },
  methods: {
    ...mapActions('costMaintain/costDetail', [
      'fetchGetCostDetail',
      'fetchGetMessageSource',
      'getInqueryNum',
      'fetchAddCost',
      'clearCrumb',
      'fetchMaintainTeam']),
    ...mapMutations('costMaintain/costDetail', [
      'setDetailSnapForm',
      'setPushCostDetail',
      'clearSendDetailFormData',
      'initDetailSnapForm',
      'setSendDetailFormData',
      'setDetailSnapForm']),
    toBack () {
      this.$router.push({ name: 'CostMaintain' })
    },
    // 去选择发送对象
    sendMaintain (detail) {
      const { id } = detail
      this.$router.push({ name: 'CostSelectMain', query: { period: this.period, id, key: this.title } })
    },
    getFieldName (e) {
      const { name } = e.target
      this.currentField = name
    },
    getFieldValue (value) {
      let result = {}
      value = Number(value)
      let denominator = this.currentField === 'realinquirynum' ? value : this.detailSnapForm['realinquirynum']
      let isDenominator = [0, ''].includes(denominator)
      if (this.currentField === 'realinquirynum') {
        if (this.detailSnapForm['netCost'] === 0) {
          result = Object.assign(result, { netCostPreInquiry: 0 })
        } else {
          let netCostValue = this.detailSnapForm['netCost']
          result = Object.assign(result, { netCostPreInquiry: isDenominator ? 0 : getFixed(netCostValue / denominator) })
        }
        if (this.detailSnapForm['grossCost'] === 0) {
          result = Object.assign(result, { grossCostPreInquiry: 0 })
        } else {
          let grossCostValue = this.detailSnapForm['grossCost']
          result = Object.assign(result, { grossCostPreInquiry: isDenominator ? 0 : getFixed(grossCostValue / denominator) })
        }
      } else if (this.currentField === 'netCost') {
        result = Object.assign(result, { netCost: value, netCostPreInquiry: isDenominator ? 0 : getFixed(value / denominator) })
      } else if (this.currentField === 'grossCost') {
        result = Object.assign(result, { grossCost: value, grossCostPreInquiry: isDenominator ? 0 : getFixed(value / denominator) })
      }
      this.setDetailSnapForm(result)
    },
    async initFormData () {
      let form = {}
      this.costDetailColumns.forEach(item => {
        let value = 0
        if (this.isSelect(item.dataIndex)) {
          value = this.detailSnapForm[item.dataIndex] ? this.detailSnapForm[item.dataIndex] : this.$t('message["855"]')
        }
        if (!this.isReadonly(item.dataIndex)) {
          value = ''
        }
        form[item.dataIndex] = value
      })
      this.setDetailSnapForm(form)
      await this.getInqueryData({ period: this.period })
    },
    isSelect (key) {
      return ['maintainContent', 'maintainFrom'].includes(key)
    },
    isReadonly (key) {
      return ['maintainContent', 'maintainFrom', 'inquirynum', 'netCostPreInquiry', 'grossCostPreInquiry'].includes(key)
    },
    isUnit (key) {
      return ['netCostPreInquiry', 'grossCostPreInquiry'].includes(key)
    },
    // 跳转到选择页
    selectContent (item) {
      let iSelect = this.isSelect(item.dataIndex)
      if (iSelect) {
        this.selectKey = item.dataIndex
        if (item.dataIndex === 'maintainContent') {
          this.sourceData = this.costContentData
          this.showSelect = true
        } else if (item.dataIndex === 'maintainFrom') {
          this.sourceData = this.perpareSourceData(this.fromDataLists)
          this.showRange = true
        }
      }
    },
    perpareSourceData (arr) {
      let snapData = []
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i]
        let oSnap = { children: [] }
        oSnap.id = item.id
        oSnap.keyname = item.hasOwnProperty('fieldkey') ? item.fieldname : ''
        oSnap.name = item.fieldname || item.name
        if (item.child && Object.prototype.toString.call(item.child) === '[object Object]') {
          for (let key in item.child) {
            let oChild = Object.assign({},
              { id: item.child[key].id },
              { name: item.child[key].fieldname },
              { keyname: item.child[key].fieldkey })
            if (item.child[key].options) {
              let children = this.perpareSourceData(item.child[key].options)
              oChild.children = children.map(cItem => {
                cItem.children.length === 0 && delete cItem.children
                return cItem
              })
            }
            oSnap.children.push(oChild)
          }
        }
        snapData.push(oSnap)
      }
      return snapData
    },
    // 准备获取询盘数据的请求参数
    perpareGetNumParams (params) {
      let result = {}
      result.period = this.period
      result.roleid = params.hasOwnProperty('roleid') ? params.roleid : 0
      result.groupid = params.hasOwnProperty('groupid') ? params.groupid : 0
      result.userid = params.hasOwnProperty('userid') ? params.userid : 0
      result.fieldval = params.hasOwnProperty('fieldval') ? params.fieldval : 0
      result.fieldkey = params.hasOwnProperty('fieldkey') ? params.fieldkey : ''
      return result
    },
    // 整理表单提交数据
    perpareSubmitFormData (params) {
      let result = Object.assign({}, params)
      result.inquirynum = this.detailSnapForm['inquirynum']
      result.realinquirynum = Number(this.detailSnapForm['realinquirynum'])
      result.grossCost = this.detailSnapForm['grossCost']
      result.netCost = this.detailSnapForm['netCost']
      return result
    },
    // 保存成本维护记录
    async saveCostRecode () {
      this.isSaveDisabled = true
      let oSendData = this.perpareGetNumParams(this.sendDetailFormData)
      let tSendData = this.perpareSubmitFormData(oSendData)
      const chain = await this.fetchAddCost(tSendData)
      chain.onSuccess(res => {
        if (this.showAdd) {
          this.showAdd = !this.showAdd
        }
        this.setPushCostDetail(res)
        this.clearCrumb()
        this.initFormData()
      })
        .fetch()
      this.isSaveDisabled = false
    },
    // 新增成本维护
    addCost () {
      let scrollHeight = 0 - this.$refs.dScroll.scrollHeight + MAX_CARD_HEIGHT
      this.$refs.scroll.scrollTo(
        0,
        scrollHeight,
        1000
      )
      this.showAdd = true
    },
    // 取消保存
    cancelSave () {
      if (this.costDetailList.length === 0) {
        this.toBack()
      } else {
        this.showAdd = false
      }
    },
    // 维护内容、范围选择内容变化后触发
    getSelectContent (res) {
      const { text, value: snapValue } = res
      if (Object.is(this.selectKey, 'maintainContent')) {
        snapValue.forEach(item => this.setSendDetailFormData({ key: item.keyname, value: item.id }))
      } else if (Object.is(this.selectKey, 'maintainFrom')) {
        const isSelectAll = Object.is(snapValue.length, 3)
        this.setSendDetailFormData({ key: 'fieldval', value: isSelectAll ? snapValue[snapValue.length - 1].id : '' })
        this.setSendDetailFormData({ key: 'fieldkey', value: isSelectAll ? 'from_search_engine' : snapValue[snapValue.length - 1].keyname })
        this.showRange = false
      }
      this.setDetailSnapForm({ [this.selectKey]: text })
      this.getInqueryData(
        this.perpareGetNumParams(this.sendDetailFormData)
      )
      this.showSelect = false
      this.showRange = false
    },
    // 获取询盘数量
    async getInqueryData (params) {
      const chain = await this.getInqueryNum(params)
      chain.onSuccess((res, all) => {
        // 设置表单数据---realinquirynum: vm.inqueeryNum
        this.setDetailSnapForm({ inquirynum: res })
      })
        .fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
.m_cost_detail {
  position: relative;
  height: 667px;
  .cube-scroll-wrapper {
    height: 667px;
  }
  .scroll {
    height: 100%;
    -webkit-overflow-scrolling: touch
  }
  .maintain_form {
    background: #f5f5f5;
    -webkit-overflow-scrolling: touch;
    margin: 12px 0;
    .cube-form-group:last-of-type {
      height: 62px;
      position: relative;
      margin-top: 12px;
    }
    .maintain_form_item:last-of-type {
      border: none
    }
    .maintain_form_item {
      position: relative;
      min-height: 56px;
      border-bottom: 1px solid #dbdbdb;
      background: #fff;
      .form_props {
        display: inline-block;
        width: 64px;
        line-height: 24px;
        color: #888;
        text-align: left;
        font-size: 16px;
        // overflow: hidden;
      }
      .form_content {
        position: absolute;
        left: 100px;
        top: 50%;
        transform: translateY(-50%);
        display: inline-block;
        width: 240px;
        // height: 25px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        .cube-input {
          background: none !important;
        }
        .cube-input-field, span{
          font-size: 16px !important;
          // font-weight: 500 !important;
          color: #333 !important;
        }
        .cubeic-arrow {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          color: #ccc;
        }
      }
    }
    .send_submit_btn {
      width: 359px;
      background: #fff;
      color: #333;
      margin: 8px;
      border: 1px solid #dbdbdb;
      border-radius: 4px;
    }
  }
  .scroll form:last-child {
    padding-bottom: 474px;
  }
  .bottom_add_btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff;
    z-index: 100;
    .add_btn {
      width: 359px;
      background: #fff;
      color: #333;
      margin: 8px;
      border: 1px solid #dbdbdb;
      border-radius: 4px;
      z-index: 11
    }
  }
  .cube-content_select {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #775;
    overflow: hidden;
  }
}
</style>
